<script>
import { Helper } from '@/mixin/helper'
import { workOrderTypesOdoo } from '../lib/workOrderTypesOdoo'

export default {
  props: {
    workOrder: {
      type: Object,
      default: () => {},
    },
    tasks: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['fleet-change', 'note-change'],
  mixins: [Helper],
  data() {
    return {
      detailWorkOrder: {
        total_fleet: null,
        note: '',
        edit_totalFleet: false,
        edit_note: false,
      },
      debounceTimer: null,
    }
  },
  computed: {
    doneStatus() {
      if (this.workOrder.wo_status === 'D') {
        return true
      }
      return false
    },
    woType() {
      return workOrderTypesOdoo().find((map) => map.code === this.workOrder.wo_type)?.name
    },
  },
  watch: {
    'detailWorkOrder.total_fleet'() {
      let self = this
      clearTimeout(self.debounceTimer)
      self.debounceTimer = setTimeout(() => {
        self.$emit('fleet-change', self.detailWorkOrder.total_fleet)
      }, 300)
    },
    'detailWorkOrder.note'() {
      let self = this
      clearTimeout(self.debounceTimer)
      self.debounceTimer = setTimeout(() => {
        self.$emit('note-change', self.detailWorkOrder.note)
      }, 300)
    },
  },
  methods: {
    async editWoDetail(field) {
      if (!this.doneStatus) {
        this.loading = true
        this.detailWorkOrder[`edit_${field}`] = true
        this.loading = false
      }
    },
    cancelTotalFleet(data, field) {
      this.loading = true

      data[`edit_${field}`] = false
      data[field] = data[`original_${field}`]
      this.loading = false
    },
    cancelEditWoDetail(field) {
      this.loading = true
      this.detailWorkOrder[`edit_${field}`] = false
      this.loading = false
    },
  },
}
</script>
<template>
  <b-card>
    <b-row>
      <b-col class="col-5">
        <div class="row">
          <div class="col-4">
            <b-form-group
              id="wo_number"
              :label="$t('workOrder.table.woNumber')"
              label-for="wo_number"
            >
            </b-form-group>
          </div>
          :
          <div class="col-7">
            {{ workOrder.wo_number }}
          </div>
        </div>
      </b-col>
      <b-col class="col-4">
        <div class="row">
          <div class="col-6">
            <b-form-group
              id="actual_installation"
              :label="$t('workOrder.table.quantityPlan')"
              label-for="actual_installation"
            >
            </b-form-group>
          </div>
          :
          <b-col class="col-5" sm="3" md="2">
            {{ workOrder.qty_plan }}
          </b-col>
        </div>
      </b-col>
      <b-col class="col-3">
        <div class="row">
          <b-col class="col-6">
            <b-form-group
              id="totalFleet"
              :label="$t('workOrder.table.totalFleet')"
              label-for="totalFleet"
            >
            </b-form-group>
          </b-col>
          :
          <b-col class="col-4 d-flex">
            <template v-if="detailWorkOrder.edit_totalFleet">
              <b-form-input
                type="number"
                v-model="detailWorkOrder.total_fleet"
                @keydown="portKeydown($event)"
                :placeholder="$t('workOrder.table.totalFleet')"
                class="h-100 col-4"
              />
              <i
                class="mc-fa icon-outline_close align-self-center"
                style="font-size: 20px"
                @click="cancelEditWoDetail('totalFleet')"
              />
            </template>
            <template v-else>
              <div @click="editWoDetail('totalFleet')" class="text-primary">
                {{ workOrder.total_fleet ? workOrder.total_fleet : 0 }}
              </div>
            </template>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="col-5">
        <b-row>
          <b-col class="col-4">
            <b-form-group
              id="customer"
              :label="$t('workOrder.table.customer')"
              label-for="customer"
            >
            </b-form-group>
          </b-col>
          :
          <b-col class="col-7">
            {{ workOrder.customer }}
          </b-col>
        </b-row>
      </b-col>

      <b-col class="col-4">
        <b-row>
          <b-col class="col-6">
            <b-form-group
              id="actual_installation"
              :label="$t('workOrder.table.actualInstall')"
              label-for="actual_installation"
            >
            </b-form-group>
          </b-col>
          :
          <b-col class="col-5">
            {{ tasks?.length }}
          </b-col>
        </b-row>
      </b-col>

      <b-col class="col-3">
        <b-row>
          <b-col class="col-6">
            <b-form-group id="version" :label="$t('workOrder.table.version')" label-for="version">
            </b-form-group>
          </b-col>
          :
          <b-col class="col-4">
            {{ workOrder.version ? workOrder.version : '-' }}
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="col-5">
        <b-row>
          <b-col class="col-4">
            <b-form-group
              id="start_date"
              :label="$t('workOrder.table.processingDate')"
              label-for="start_date"
            >
            </b-form-group>
          </b-col>
          :
          <b-col class="col-7">
            {{ momentDMHms(workOrder.plan_date) }}
          </b-col>
        </b-row>
      </b-col>

      <b-col class="col-4">
        <b-row>
          <b-col class="col-6">
            <b-form-group id="wo_type" :label="$t('workOrder.table.woType')" label-for="woType">
            </b-form-group>
          </b-col>
          :
          <b-col class="col-5">
            {{ woType }}
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="col-5">
        <b-row>
          <b-col class="col-4">
            <b-form-group id="note" :label="$t('workOrder.table.note')" label-for="note">
            </b-form-group>
          </b-col>
          :
          <b-col class="col-7">
            <template v-if="detailWorkOrder.edit_note">
              <b-form-input
                v-model="detailWorkOrder.note"
                :placeholder="$t('workOrder.table.note')"
              />
              <i
                class="mc-fa icon-outline_close"
                style="font-size: 20px"
                @click="cancelEditWoDetail('note')"
              />
            </template>
            <template v-else>
              <div @click="editWoDetail('note')" class="text-primary">
                {{ workOrder.note ? workOrder.note : '-' }}
              </div>
            </template>
          </b-col>
        </b-row>
      </b-col>

      <b-col class="col-4">
        <b-row>
          <b-col class="col-6">
            <b-form-group
              id="technician"
              :label="$t('workOrder.table.technician')"
              label-for="technician"
            >
            </b-form-group>
          </b-col>
          :
          <b-col class="col-5">
            {{ workOrder.teknisi ? workOrder.teknisi : '-' }}
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="col-5">
        <b-row>
          <b-col class="col-4">
            <b-form-group
              id="internal_note"
              :label="$t('workOrder.internalNote')"
              label-for="customer"
            >
            </b-form-group>
          </b-col>
          :
          <b-col class="col-7" v-html="workOrder.internal_note"></b-col>
        </b-row>
        <b-row>
          <b-col class="col-4">
            <b-form-group
              id="planner"
              label="Planner"
              label-for="planner"
            >
            </b-form-group>
          </b-col>
          :
          <b-col class="col-7" v-html="workOrder.planner"></b-col>
        </b-row>
      </b-col>
      <b-col class="col-4">
        <b-row>
          <b-col class="col-6">
            <b-form-group
              id="done_by_username"
              :label="$t('workOrder.table.doneBy')"
              label-for="done_by_username"
            >
            </b-form-group>
          </b-col>
          :
          <b-col class="col-5">
            {{ workOrder.done_by_username ? workOrder.done_by_username : '-' }}
          </b-col>
        </b-row>
        <b-row>
          <b-col class="col-6">
            <b-form-group
              id="canceled_by_username"
              :label="$t('workOrder.table.canceledBy')"
              label-for="canceled_by_username"
            >
            </b-form-group>
          </b-col>
          :
          <b-col class="col-5">
            {{ workOrder.canceled_by_username ? workOrder.canceled_by_username : '-' }}
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>
